import { connect } from 'react-redux'
import { get } from 'lodash'
import WishlistTableComponent from '../components/WishlistTable'
import {
  removeWishlistedProduct,
  fetchWishlistedProducts
} from '../actions/ApiRequest'

const mapStateToProps = state => {
  const pagination = {
    current: get(state, 'buyerWishlist.pagination.current_page', null),
    pageSize: get(state, 'buyerWishlist.pagination.per_page', null),
    defaultPageSize: get(state, 'buyerWishlist.pagination.per_page', null),
    total: get(state, 'buyerWishlist.pagination.total', null),
  }
  return ({
    products: state.buyerWishlist.products,
    loading: state.buyerWishlist.isLoading,
    pagination: pagination,
  })
}

const mapDispatchToProps = dispatch => ({
  onChangePag: page => dispatch(fetchWishlistedProducts({ page })),
  removeWishlistedProduct: (product) => dispatch(removeWishlistedProduct(product))
})

const TransactionList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(WishlistTableComponent)

export default TransactionList